import ArtifactGroupType from "../base/ArtifactGroupType";


const AchillesArmor = {
  id: '142',
  name: "Achilles' Armor",
  groupIcon: 'LegendsOfTroy',
  type: ArtifactGroupType.LEGENDS_OF_TROY,
  icon: 'AchillesArmor',
  power: 10,
  gameId: 'AchillesArmor'
};

export default AchillesArmor;
